/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { Component } from '@angular/core';
import {
  AbstractControl,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OSKCookieConsent } from './models/cookie_consent.model';
import { AsyncPipe, NgClass } from '@angular/common';
import { OSKButtonComponent, OSKIconComponent } from '@oskey/ui';
import { OSKTranslatePipe } from '../../core/translate';

@Component({
  selector: 'osk-cookie-consent-banner',
  templateUrl: './cookie_consent_banner.component.html',
  styleUrls: ['./cookie_consent_banner.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, AsyncPipe, OSKTranslatePipe, OSKButtonComponent, OSKIconComponent]
})
export class OSKCookieConsentBannerComponent {
  public wasSubmitted = false;
  public cookieConsentForm: UntypedFormGroup;

  constructor(
    private _modalService: NgbActiveModal,
    private _formBuilder: UntypedFormBuilder,
    private _coockieConsent: OSKCookieConsent
  ) {
    this.cookieConsentForm = this._formBuilder.group({
      consentToStricklyNecessaryCookies: new UntypedFormControl(
        { value: true, disabled: true },
        [Validators.requiredTrue]
      ),
      consentToPerformanceCookies: new UntypedFormControl(
        Boolean(this._coockieConsent?.consentToPerformanceCookies)
      ),
      consentToTargetingCookies: new UntypedFormControl(
        Boolean(this._coockieConsent?.consentToTargetingCookies)
      )
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.cookieConsentForm.controls;
  }

  close(onlyStricklyNecessaryCookies?: boolean): void {
    this.wasSubmitted = true;
    const cookieConsent: OSKCookieConsent = {
      consentToStricklyNecessaryCookies: true,
      consentToPerformanceCookies: onlyStricklyNecessaryCookies
        ? false
        : Boolean(this.cookieConsentForm.get('consentToPerformanceCookies')?.value),
      consentToTargetingCookies: onlyStricklyNecessaryCookies
        ? false
        : Boolean(this.cookieConsentForm.get('consentToTargetingCookies')?.value)
    };
    this._modalService.close(cookieConsent);
  }
}
